import { cn } from '@/lib/utils'
import { LogoIcon } from './Logo'

/**
 * Marketing-site logo: the T mark followed by the wordmark set in the
 * display face (Boldonse), matching the giant footer signature. The app and
 * add-ins keep the T mark (`Logo`) on its own.
 */
export function LogoWordmark({ size = 'md', className }: { size?: 'sm' | 'md' | 'lg'; className?: string }) {
  const mark = size === 'lg' ? 32 : size === 'sm' ? 22 : 26
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <LogoIcon size={mark} />
      <span
        className={cn(
          'font-[family-name:var(--font-landing-display)] uppercase leading-none tracking-[-0.02em] text-[#0a0a0a] dark:text-white',
          size === 'lg' ? 'text-[1.6rem]' : size === 'sm' ? 'text-[1.05rem]' : 'text-[1.3rem]'
        )}
      >
        Templatean
      </span>
    </span>
  )
}

export default LogoWordmark
